export default __webpack_public_path__ + "static/media/all-platforms.9b2a9241.png";